module.exports = __webpack_public_path__ + "img/lot_instruction.370a0b84.png";